import { useEffect, useRef, useState } from 'react';

interface ScrollDetails {
  x: number;
  y: number;
}

export const useWindowScroll = () => {
  // Store the last-known scroll position (when this is initialized, it is set to 0).
  const [scroll, setScroll] = useState<ScrollDetails>({
    x: 0,
    y: 0,
  });

  const rafId = useRef<number>();

  useEffect(() => {
    const calculateWindowScroll = () => {
      setScroll({
        x: window.scrollX,
        y: window.scrollY,
      });
      rafId.current = undefined;
    };

    const handleScroll = () => {
      if (!rafId.current) {
        rafId.current = requestAnimationFrame(calculateWindowScroll);
      }
    };

    calculateWindowScroll();

    // Listen to window scroll events to decide when to re-evaluate the scroll position.
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (rafId.current) {
        cancelAnimationFrame(rafId.current);
      }
    };
  }, []);

  return scroll;
};
